import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header({ isDrawerOpen, toggleDrawer }) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  
  // Pages with dark hero sections need white hamburger/logo initially
  const darkHeroPages = ['/', '/talent', '/brands', '/contact'];
  const hasDarkHero = darkHeroPages.includes(location.pathname);
  
  // Use light mode (dark text) only on pages with light backgrounds or when scrolled
  const isLightMode = !hasDarkHero || isScrolled;

  useEffect(() => {
    const handleScroll = () => {
      // Switch to dark logo after scrolling past 80% of viewport height
      const scrollThreshold = window.innerHeight * 0.8;
      setIsScrolled(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Reset scroll state when navigating to a new page
  useEffect(() => {
    setIsScrolled(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <header className={`header ${isLightMode ? 'light-mode' : ''} ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img src="/logo.webp" alt="Alooma Media Group" className="logo-image" />
        </Link>
        
        <button 
          className={`hamburger ${isDrawerOpen ? 'active' : ''}`} 
          onClick={toggleDrawer}
          aria-label="Toggle menu"
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
